<script>
import CapBo from "./capBo.vue";
import CapTruong from "./capTruong.vue";
import CapTinh from "./capTinh.vue";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
    CapBo,
    CapTruong,
    CapTinh
  },
  data() {
    return {
      title: "Quản lý thông báo",
      dofficeTitle: " | DOffice - Đại học Đồng Tháp",
      itemFilter: {
        ngayBatDauTao: null,
        ngayKetThucTao: null,
        ngayBatDauHetHan: null,
        ngayKetThucHetHan: null,
        nguoiTao: null,
        trangThai: null,
        trangThaiXem: null,
        maTraCuu: null,
        tuKhoa: null,
      },
      trangThaiXem: [
        {
          id: "DAXEM",
          name: "Đã xem"
        },
        {
          id: "CHUAXEM",
          name: "Chưa xem"
        },
      ],
      optionsUser: [],
      countTruong: {
        daXem: 0,
        chuaXem: 0,
        tongSo: 0
      },
      countTinh: {
        daXem: 0,
        chuaXem: 0,
        tongSo: 0
      },
      countBo: {
        daXem: 0,
        chuaXem: 0,
        tongSo: 0
      }
    };
  },
  validations: {},
  created() {
    document.title = "Thông báo cấp trường" + this.dofficeTitle;
    this.getUser();
  },
  watch: {
    currentPage: {},
    computed: {},
    methods: {}
  },
  methods: {
    changeTitleInHeader(title) {
      document.title = title + this.dofficeTitle;
    },
    async getUser() {
      try {
        await this.$store.dispatch("userStore/getAll").then(resp => {
          if (resp.resultCode == "SUCCESS") {
            let items = resp.data
            this.loading = false
            this.optionsUser = items;
          }
          return [];
        });
      } finally {
        this.loading = false
      }
    },
  }
}
</script>

<template>
  <div>
    <!--    <PageHeader :title="title" :items="items"/>-->
    <div class="row mb-1" style="padding: 10px">
      <div class="col-12">
        <div class="row">
          <div class="col-md-4 col-12 d-flex align-items-center">
            <h4 class="font-size-18 fw-bold text-dark"> {{ title }}</h4>
          </div>
        </div>
        <div class="row" style="background-color: #fff; padding: 10px">
          <div class="col-12">

            <div class="d-flex justify-content-around align-items-end flex-wrap">
              <div class="flex-grow-1 me-2">
                <label class="mb-1">Người tạo</label>
                <multiselect v-model="itemFilter.nguoiGui" :options="optionsUser" track-by="id" label="fullName"
                             placeholder="Chọn người gửi" deselect-label="Nhấn để xoá"
                             selectLabel="Nhấn enter để chọn"
                             selectedLabel="Đã chọn">

                  <template slot="singleLabel" slot-scope="{ option }">
                    <strong>{{ option.fullName }}</strong>

                    <span v-if="option.donVi" style="color:red">&nbsp;{{ option.donVi.ten }}</span>
                  </template>
                  <template slot="option" slot-scope="{ option }">
                    <div class="option__desc">
          <span class="option__title">
            <strong>{{ option.fullName }}&nbsp;</strong>
          </span>
                      <span v-if="option.donVi" class="option__small"
                            style="color:green">{{ option.donVi.ten }}</span>
                    </div>
                  </template>

                </multiselect>
              </div>
              <div class="flex-grow-1 me-2">
                <label class="mb-1">Trạng thái xem</label>
                <multiselect v-model="itemFilter.trangThaiXem" :options="trangThaiXem" track-by="id" label="name"
                             placeholder="Chọn trạng thái xem" deselect-label="Nhấn để xoá"
                             selectLabel="Nhấn enter để chọn"
                             selectedLabel="Đã chọn"></multiselect>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row p-2">
      <div class="col-12">
        <b-tabs content-class="" nav-class="cs-tabs">
          <b-tab active class="border-0" @click="changeTitleInHeader('Thông báo cấp trường')">
            <template v-slot:title>
              <div>
                                        <span class="d-inline-block d-sm-none">
                                            <i class="fas fa-home"></i>
                                        </span>
                <span class="d-none d-sm-inline-block"
                      style="text-align: center"> Cấp trường <br/>Chưa xem: {{ countTruong.chuaXem }} | Đã xem: {{ countTruong.daXem }} | Tổng {{ countTruong.tongSo }}</span>
              </div>
            </template>
            <p>
              <CapTruong :itemFilter="itemFilter" :count.sync="countTruong"/>
            </p>
          </b-tab>
          <b-tab @click="changeTitleInHeader('Thông báo cấp tỉnh')">
            <template v-slot:title>
              <div>
                                        <span class="d-inline-block d-sm-none">
                                            <i class="far fa-user"></i>
                                        </span>
                <span class="d-none d-sm-inline-block"
                      style="text-align: center"> Cấp tỉnh <br/> Chưa xem: {{ countTinh.chuaXem }} | Đã xem: {{ countTinh.daXem }} | Tổng {{ countTinh.tongSo }}</span>
              </div>

            </template>
            <p>
              <CapTinh :itemFilter="itemFilter" :count.sync="countTinh"/>
            </p>

          </b-tab>
          <b-tab @click="changeTitleInHeader('Thông báo cấp bộ')">
            <template v-slot:title>
              <div>
                                        <span class="d-inline-block d-sm-none">
                                            <i class="far fa-envelope"></i>
                                        </span>
                <span class="d-none d-sm-inline-block"
                      style="text-align: center"> Cấp bộ <br/> Chưa xem: {{ countBo.chuaXem }} | Đã xem: {{ countBo.daXem }} | Tổng {{ countBo.tongSo }}</span>
              </div>

            </template>
            <p>
              <CapBo :itemFilter="itemFilter" :count.sync="countBo"/>
            </p>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>
